module.exports = __webpack_public_path__ + "img/carSatus.6b17e43f.png";